export default {
    dealership: 'At dealership',
    customer: 'At customer location',
    custom: 'Custom',
};
